import React from 'react';
import PlusSmall from '@uber/base-icons/plus-small';
import { useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { FRAME_CLASSIFICATION_PANEL_CONSTANTS } from './constants';
type FrameClassificationPanelFooterProps = {
  annotationLabelTitle: string;
  isEditMode: boolean;
  canSave: boolean;
  onCancel: () => void;
  onSave: () => void;
};
export const FrameClassificationPanelFooter = ({
  annotationLabelTitle,
  isEditMode,
  canSave,
  onCancel,
  onSave
}: FrameClassificationPanelFooterProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.sizing.scale400,
    padding: theme.sizing.scale600,
    borderTop: `1px solid ${theme.colors.borderOpaque}`
  })}>
      <Button kind={KIND.tertiary} size={SIZE.xSmall} onClick={onCancel}>
        {FRAME_CLASSIFICATION_PANEL_CONSTANTS.CANCEL_BUTTON}
      </Button>
      <Button kind={KIND.primary} size={SIZE.xSmall} disabled={!canSave} endEnhancer={!isEditMode ? () => <PlusSmall size={16} /> : undefined} onClick={onSave}>
        {isEditMode ? FRAME_CLASSIFICATION_PANEL_CONSTANTS.SAVE_BUTTON : `${FRAME_CLASSIFICATION_PANEL_CONSTANTS.CREATE_BUTTON_PREFIX} ${annotationLabelTitle}`}
      </Button>
    </div>;
};